import React from "react";

const Tooltip = ({ text, children, show }) => {
  if (!show) return children;
  
  return (
    <div style={{ position: 'relative' }}>
      {children}
      <div style={{
        position: 'absolute',
        bottom: '100%',
        right: 0,
        marginBottom: '5px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        color: '#000',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        zIndex: 1000,
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
      }}>
        {text}
      </div>
    </div>
  );
};

export default Tooltip; 